module.exports = __webpack_public_path__ + "img/trunk_11x2.d32ecd33.svg";